(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('PremDiscGroupDetailController', PremDiscGroupDetailController);

    PremDiscGroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PremDiscGroup', 'PremDisc'];

    function PremDiscGroupDetailController($scope, $rootScope, $stateParams, previousState, entity, PremDiscGroup, PremDisc) {
        var vm = this;

        vm.premDiscGroup = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccsTrApp:premDiscGroupUpdate', function(event, result) {
            vm.premDiscGroup = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
